import { miniUpdates } from "@/mocks/home";

export default function Hero() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 pb-8 pt-6 md:px-6 md:pb-12 md:pt-8">
      {/* eyebrow / date */}
      <div className="mb-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div className="inline-flex items-center gap-2 text-sm text-foreground-600">
          <span className="inline-flex items-center gap-1.5 rounded-md bg-accent-500 px-2.5 py-1 text-xs font-bold text-background-50">
            <i className="ri-vip-crown-2-line" /> 主编精选
          </span>
          <span>今日头条 · 编辑部逐帧核对中</span>
        </div>
        <span className="text-xs tracking-wide text-foreground-500">
          2026 年 9 月 9 日 · 已更新 128 条爆料
        </span>
      </div>

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
        {/* lead image card */}
        <article className="group relative overflow-hidden rounded-xl lg:col-span-2">
          <div className="relative aspect-[16/9] w-full overflow-hidden md:aspect-[21/10]">
            <img
              src="https://readdy.ai/api/search-image?query=dramatic%20press%20conference%20wall%20crowded%20with%20television%20cameras%20and%20microphone%20booms%20at%20night%2C%20reporter%20flashes%20and%20crimson%20red%20bokeh%20lights%2C%20deep%20crimson%20and%20warm%20amber%20color%20grade%2C%20shallow%20depth%20of%20field%2C%20cinematic%20editorial%20news%20photography%2C%20high-end%20magazine%20quality%2C%20atmospheric%20and%20moody&width=1600&height=760&seq=lead-press&orientation=landscape"
              alt="深夜剧组互撕录音门事件现场头条报道配图"
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-black/10" />
          <div className="absolute inset-x-0 bottom-0 flex flex-col gap-3 p-4 md:p-7">
            <div className="flex items-center gap-2">
              <span className="rounded-md bg-primary-600 px-2.5 py-1 text-xs font-bold text-background-50">🔥 高热</span>
              <span className="rounded-md border border-background-50/30 px-2.5 py-1 text-xs text-background-50/90">剧组 · 事件追踪</span>
            </div>
            <h1 className="font-heading max-w-3xl text-2xl font-black leading-snug text-background-50 md:text-4xl">
              录音门升级：现场同事晒工作记录，冲突时间线出现多处出入
            </h1>
            <p className="hidden max-w-2xl text-sm text-background-50/85 sm:block md:text-base">
              从深夜首曝到导演喊话，再到在场同事晒出反证，一个录音引出的新瓜越滚越大，双方说法孰真孰假仍在核对。
            </p>
            <div className="mt-1 flex flex-wrap items-center gap-4">
              <a
                href="#track"
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-500 px-4 py-2 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400"
              >
                查看完整时间线
                <i className="ri-arrow-right-line" />
              </a>
              <span className="flex items-center gap-1.5 text-xs text-background-50/80">
                <i className="ri-eye-line" /> 51 万人在看 · 更新于 10:12
              </span>
            </div>
          </div>
        </article>

        {/* today's new瓜 side card */}
        <aside className="flex flex-col rounded-xl border border-background-200 bg-background-50">
          <div className="flex items-center justify-between border-b border-background-200 px-4 py-3">
            <div className="flex items-center gap-2 text-sm font-bold text-foreground-900">
              <span className="flex h-5 w-5 items-center justify-center rounded bg-secondary-200 text-secondary-800">
                <i className="ri-flashlight-line text-xs" />
              </span>
              今日新瓜实时刷新
            </div>
            <span className="flex items-center gap-1.5 text-xs text-foreground-500">
              <span className="h-1.5 w-1.5 animate-pulseDot rounded-full bg-primary-500" />
              直播中
            </span>
          </div>
          <div className="flex flex-1 flex-col divide-y divide-background-100">
            {miniUpdates.map((m, i) => (
              <a
                key={m.title}
                href="#stream"
                className="group flex items-center gap-3 px-4 py-3 transition-colors hover:bg-background-100"
              >
                <span className="font-mono text-xs tabular-nums text-foreground-400">{m.time}</span>
                <span className="flex-1 truncate text-sm text-foreground-700 group-hover:text-primary-700">
                  {m.title}
                </span>
                <span className="rounded bg-background-200 px-1.5 py-0.5 text-[10px] text-foreground-500">{m.tag}</span>
              </a>
            ))}
          </div>
          <a
            href="#flash"
            className="m-3 inline-flex items-center justify-center gap-1 whitespace-nowrap rounded-lg border border-background-200 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            进入今日快讯
            <i className="ri-arrow-right-line text-sm" />
          </a>
        </aside>
      </div>
    </section>
  );
}